module.exports = __webpack_public_path__ + "static/img/manual-26.e6049b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-26.png
// module id = 6BHE
// module chunks = 4